import { render, staticRenderFns } from "./serviceHistory.vue?vue&type=template&id=788e5154&scoped=true"
import script from "./serviceHistory.vue?vue&type=script&lang=js"
export * from "./serviceHistory.vue?vue&type=script&lang=js"
import style0 from "./serviceHistory.vue?vue&type=style&index=0&id=788e5154&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788e5154",
  null
  
)

export default component.exports